import { useAuthStore } from '@pharmsnap/shared/src/composition'
import { defineComponent } from '@vue/composition-api'
import { CopilotSideBarDialog } from '../Copilot/CopilotSideBarDialog'
export const CopilotDialogWithAuth = defineComponent({
  name: 'CopilotDialogWithAuth',
  props: {},
  setup() {
    const {
      getters: { isSupportCopilot },
    } = useAuthStore()
    return { isSupportCopilot }
  },
  render() {
    if (this.isSupportCopilot) {
      return <CopilotSideBarDialog {...{ props: this.$props }} />
    }
    return <div></div>
  },
})
